import React, { useState } from 'react';
import { TeamLineupsNav } from './nav/TeamLineupsNav';
import PropTypes from 'prop-types';

import { TeamLineupsList } from './item/TeamLineupsList';
import { useGetCurrentCompFilters } from 'common/react/components/competition-nav/hooks/use-get-current-comp-filters';

export const TeamLineups = ({ data }) => {
    const { competitionId, competitionPid, compSeason, round } =
        useGetCurrentCompFilters();

    const [expandLineups, setExpandLineups] = useState(false);

    return (
        <>
            <TeamLineupsNav
                {...data}
                expandLineups={expandLineups}
                setExpandLineups={setExpandLineups}
            />

            {!competitionId ||
            !compSeason?.id ||
            (!round?.roundNumber && round?.roundNumber !== 0) ? (
                <></>
            ) : (
                <TeamLineupsList
                    {...data}
                    expandLineups={expandLineups}
                    competitionId={competitionId}
                    competitionPid={competitionPid}
                    compSeason={compSeason}
                    roundNumber={round.roundNumber}
                />
            )}
        </>
    );
};

TeamLineups.propTypes = {
    data: PropTypes.object.isRequired
};
